module.exports = __webpack_public_path__ + "img/tpc-36.02857fcc.jpg";